import { Objects as ObjectTypes } from '@/types/objects';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Objects {
    static entries = <T extends object>(obj: T): ObjectTypes.Entries<Required<T>> =>
        Object.entries(obj) as ObjectTypes.Entries<T>;

    static keys = <T extends object>(obj: T): ObjectTypes.Keys<T> =>
        Object.keys(obj) as ObjectTypes.Keys<T>;

    static values = <T extends object>(obj: T): ObjectTypes.Values<T> =>
        Object.values(obj) as ObjectTypes.Values<T>;

    static fromEntries = <K extends string, V>(entries: [K, V][]): Record<K, V> =>
        Object.fromEntries(entries) as Record<K, V>;
}
